export default "__VITE_PUBLIC_ASSET__a84e8ee5__"